export default __webpack_public_path__ + "static/media/gen.5fda53ce.svg";